var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTequila(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D5E2DA;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#F8BB27;}\n\t.st3{fill:#E09C25;}\n\t.st4{fill:#37A836;}\n\t.st5{fill:#82BF67;}\n\t.st6{fill:#6BB055;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.75,183.78c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.45,149.49,62.06,183.78,104.75,183.78"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.99,64.35h48.62l-6.98,80.19c-0.17,1.94-1.79,3.43-3.74,3.43h-26.83c-1.94,0-3.56-1.48-3.74-3.41 L89.99,64.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.65,77.27h37.29l-5.58,54.38l0,0c-8.05,3.97-17.48,4.01-25.58,0.13l-0.27-0.13L95.65,77.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.03,98.09c-0.7,1.65-2.6,2.42-4.24,1.72c-1.65-0.7-2.42-2.59-1.72-4.24c0.7-1.65,2.59-2.42,4.24-1.72 C107.95,94.55,108.72,96.45,108.03,98.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M126.2,109.29c-0.7,1.65-2.59,2.42-4.24,1.72c-1.65-0.7-2.42-2.59-1.72-4.24c0.7-1.65,2.6-2.42,4.24-1.72 C126.13,105.75,126.9,107.65,126.2,109.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M116.05,114.26c-0.46,1.1-1.73,1.61-2.83,1.15c-1.1-0.46-1.61-1.73-1.14-2.83c0.46-1.1,1.73-1.61,2.82-1.15 C116,111.9,116.51,113.16,116.05,114.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.72,141.63c1-1.33,0.53-3.2-0.91-4.06l-42.76-25.6c-1.43-0.86-3.3-0.39-4,1.12 c-5.91,12.8-1.33,28.25,11.03,35.66C82.45,156.15,98.23,152.89,106.72,141.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M73.18,143.57c10.36,6.2,23.84,2.82,30.04-7.54l-37.58-22.5C59.44,123.89,62.82,137.36,73.18,143.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.43,124.78l-11.25,18.79c10.36,6.2,23.84,2.82,30.04-7.54L84.43,124.78z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.38,144.55l6.54-69.13c0.14-1.44-0.93-2.61-2.37-2.61h-16.14v78.25h4.81 C127.83,151.07,131.04,148.15,131.38,144.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTequila);
export default __webpack_public_path__ + "static/media/Tequila.4219a5b1fbf300b60918781642a444fa.svg";
export { ForwardRef as ReactComponent };